import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {
  }

  handleError(error: any): void {
    const normalizedError = this.normalizeError(error);
    const http = this.injector.get(HttpClient);
    const router = this.injector.get(Router, null);

    const windowRef = window as unknown as { __globalErrorCount?: number };
    windowRef.__globalErrorCount = (windowRef.__globalErrorCount || 0) + 1;
    if (windowRef.__globalErrorCount > 5) {
      console.error('GlobalErrorHandler suppressed error:', normalizedError);
      return;
    }

    const reportObject = {
      status: normalizedError.status,
      name: normalizedError.name,
      message: normalizedError.message,
      stack: normalizedError.stack,
      url: location.href,
      route: router ? router.url : undefined,
      userAgent: navigator.userAgent,
    };

    http.post('/exceptions', reportObject).subscribe({
      error: () => {
        // Ignore reporting errors to avoid infinite loops.
      },
    });

    console.error('GlobalErrorHandler caught:', normalizedError);
  }

  private normalizeError(error: any): {
    name: string;
    message: string;
    stack?: string;
    status?: number;
  } {
    const originalError = error?.rejection ?? error;

    if (originalError instanceof HttpErrorResponse) {
      return {
        name: 'HttpErrorResponse',
        message: originalError.message,
        stack: originalError.error?.stack,
        status: originalError.status,
      };
    }

    return {
      name: originalError?.name || 'Error',
      message: originalError?.message || String(originalError),
      stack: originalError?.stack,
      status: originalError?.status,
    };
  }
}
